import { Injectable } from "@angular/core";
import { IID_GISFO_WORKORDER } from "@common/interfaces/interfaceData";
import { AbstractInterfaceDataQuery } from "../interfaceDataModel";
import { IIDGisfoWorkorderStore } from "./iidGisfoWorkorder.store";
import { InterfaceDataQuery } from '../interfaceDataRegistry';
import { InterfaceName } from '@common/interfaces/issueTypeInterface';

@Injectable({
  providedIn: "root",
})
@InterfaceDataQuery(InterfaceName.GISFO_WORKORDER)
export class IIDGisfoWorkorderQuery extends AbstractInterfaceDataQuery<IID_GISFO_WORKORDER> {
  constructor(protected store: IIDGisfoWorkorderStore) {
    super(store);
  }
}
